import { Link } from "react-router-dom"
import imageMedios from "../../Assets/imageMedios"

const { ambitoLogo, clarinLogo, noticiasargentinasLogo, forbesLogo,
    motor1Logo, cronistaLogo, diariocarlospazLogo, bariloche2000Logo,
    eleconomistaLogo, diarioDelEste, infoNegocios, epd, subrayado, carmelo, ladiaria, elpais } = imageMedios

export type PaisType = "AR" | "UY" | "BR"
interface CobProps {
    icon: string
    label: string
    link: string
    pais: PaisType[]
}
interface INovedades {
    titulo?: string;
    descripcion: string;
    link: string;
    pais: PaisType;
    img?: any;
}

export const informacion_contacto = {
    fijo: "0810-444-SEGURO (7348)",
    whatsApp: "+54 9 11 2835 7048",
    horarios: {
        ventas: "lunes a viernes de 08:30 a 20:30hs.",
        atencion_cliente: "lunes a viernes de 09:00 a 18:00hs."
    }
}
export const testimonios_clientes = [
    {
        nombre: "Max G.",
        texto: "Excelente atención por parte de sus asistentes. Empatía- cordialidad- respeto. Lo recomiendo 100%.",
        calificacion: 5
    },
    {
        nombre: "Luis",
        texto: "La atención telefónica es más que excelente. Siempre muy bien dispuestos.",
        calificacion: 5
    },
    {
        nombre: "Christian L.",
        texto: "Atención muy rápida , amable y eficiente.",
        calificacion: 5
    },
    {
        nombre: "Ariana A.",
        texto: "Buena atención y rápida respuesta, super recomendado.",
        calificacion: 5
    },
    {
        nombre: "Dana F.",
        texto: "La atención telefónica ha sido buena y amable solucionando mí asunto.",
        calificacion: 4
    },
    {
        nombre: "Carlos M.",
        texto: "Excelente atención, cada vez que me contacté fueron muy operativos.",
        calificacion: 5
    },
    {
        nombre: "Luciano P.",
        texto: "Muy buena atención. Me resolvió rápido lo solicitado. Gracias!!",
        calificacion: 5
    },
    {
        nombre: "Marcela C.",
        texto: "Excelente atención muy rápido me solucionaron el problema la póliza llego por pdf en 5 minutos.",
        calificacion: 4
    },
    {
        nombre: "Martin A.",
        texto: "Estoy muy conforme, con la atención sobretodo, es rápida y simple. Muy recomendable.",
        calificacion: 5
    },
    {
        nombre: "Gladis M.",
        texto: "El servicio de WhatsApp que ofrecen es práctico y resuelven rápido las inquietudes.",
        calificacion: 4
    }
];

//---------------------------------------------


//Landing Pymes -------------------------------

export const pymes_propuesta_valor = [
    {
        titulo: "Respuesta inmediata",
        descripcion: "Soluciones corporativas a medida y con el respaldo de aseguradoras de primer nivel.",
        icono: "#icon-motivo-rapido"
    },
    {
        titulo: "Gestión de siniestros",
        descripcion: "Gestiones legales ante las aseguradoras para agilizar el pago de siniestros propios y de terceros.",
        icono: "#icon-motivo-g-siniestros"
    },
    {
        titulo: "Experiencia y profesionalismo",
        descripcion: "Contamos con un equipo de ejecutivos exclusivos por riesgo y mercado.",
        icono: "#icon-motivo-experiencia"
    },
    {
        titulo: "Gestiones comerciales",
        descripcion: "Asesoramiento y seguimiento de trámites, actualizaciones de sumas aseguradas, renovaciones y cobranzas.",
        icono: "#icon-motivo-g-comercial"
    },
]

export const pymes_coberturas: CobProps[] = [
    {
        icon: "#icon-seg-art",
        label: "ART",
        link: "/seguros-corporativos-ART",
        pais: ["AR"]
    },
    {
        icon: "#icon-seg-comercio",
        label: "Integral de Comercio",
        link: "/seguros-corporativos-integral-comercio",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-caucion",
        label: "Caución",
        link: "/seguros-corporativos-caucion",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-rc",
        label: "RC",
        link: "/seguros-corporativos-RC",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-flota",
        label: "Flota de Vehículos",
        link: "/seguros-corporativos-flota",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-incendio-corp",
        label: "Incendio Corporativo",
        link: "/seguros-corporativos-incendio",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-mala-praxis",
        label: "Mala Praxis",
        link: "/seguros-corporativos-mala-praxis",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-rc-medioambiental",
        label: "RC Medioambiental",
        link: "/seguros-corporativos-RC-medioambiental",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-tr-corp",
        label: "Todo Riesgo Operativo",
        link: "/seguros-corporativos-todo-riesgo-operativo",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-construccion",
        label: "RC Construcción",
        link: "/seguros-corporativos-construccion",
        pais: ["AR"]
    },
    {
        icon: "#icon-seg-transporte",
        label: "Transporte",
        link: "/seguros-corporativos-transporte",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-consorcio",
        label: "Consorcio",
        link: "/seguros-corporativos-consorcio",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-credito",
        label: "Crédito",
        link: "/seguros-corporativos-credito",
        pais: ["AR",]
    },
    {
        icon: "#icon-seg-agro",
        label: "Agro",
        link: "/seguros-corporativos-agro",
        pais: ["AR"]
    },
    {
        icon: "#icon-seg-vida-corp",
        label: "Vida Corporativa",
        link: "/seguros-corporativos-vida",
        pais: ["AR",]
    },
    /*{
        icon: "#icon-seg-caucion",
        label: "Garantía de alquiler",
        link: "/seguros-corporativos-garantia-alquiler",
        pais: ["UY"]
    },*/
]
//----------------------------------------------

//Landing Sustentabilidad --------------------------------

export const Sustentabilidad_historias = [
    {
        titulo: "Nuevo uso para equipos de Segurarse",
        descripcion: "¿Ya escucharon hablar de la tecnología circular? ♻️ cada vez más, como sociedad, nos concientizamos y nos involucramos en el impacto ambiental de todas nuestras acciones🌏🌏 ",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:7103069100297363457/",
        img: require("../../Assets/img/landing/sustentabilidad/Donacion_Escuela_PCs.jpeg")
    },
    {
        titulo: "¡Vamos a jugar!",
        descripcion: "Compartimos una tarde de juegos con los chic@s que asisten al Virreyes Rugby Club semanalmente para realizar diversas actividades deportivas, clases de baile, cursos de formación educativa, ¡y mucho más!",
        link: "https://www.linkedin.com/posts/segurarse_programa-sustentabilidad-daedadelaniaehez-activity-6967552730512961536-0cjK?utm_source=share&utm_medium=member_desktop",
        img: require("../../Assets/img/landing/sustentabilidad/Club_Virreyes.JPG")
    },
    {
        titulo: "Donaciones en Casa Garraham",
        descripcion: "Agradecemos a Fundación Garrahan que nos abrió las puertas de la Casa Garraham para acercar juguetes y ropa para los niñ@s y sus familias que residen en ella.",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:6834181013044789248/",
        img: require("../../Assets/img/landing/sustentabilidad/Garrahan.jpeg")
    },
    // {
    //     titulo: "Segunda oportunidad para las computadoras de Segurarse",
    //     descripcion: "¿Ya escucharon hablar de la tecnología circular? ♻️ cada vez más, como sociedad, nos concientizamos y nos involucramos en el impacto ambiental de todas nuestras acciones🌏🌏",
    //     link: "https://www.linkedin.com/feed/update/urn:li:activity:7103069100297363457/",
    //     img: require("../../Assets/img/landing/sustentabilidad/Escuela_11_Ricardo_Gutierrez.jpeg")
    // }
]

//----------------------------------------------


//Landing Home --------------------------------

export const home_novedades: INovedades[] = [
    {
        titulo: "¿Qué me pueden exigir (y qué no) durante un control de tránsito en la ruta?",
        descripcion: "Si pensás salir de vacaciones en tu auto durante este verano, es importante que cumplas todos los requisitos legales y técnicos para viajar seguro.",
        link: "https://segurarse.com.ar/blog/2023/01/23/que-me-pueden-exigir-y-que-no-durante-un-control-de-transito-en-la-ruta/",
        pais: "AR"
    },
    {
        titulo: "Puntos de incapacidad en la ART: qué son y cómo calcularlos",
        descripcion: "En un seguro de ART, cuantos más puntos de incapacidad tenga el damnificado, mayor será su indemnización a cobrar.",
        link: "https://segurarse.com.ar/blog/2024/03/05/puntos-de-incapacidad-en-la-art-que-son-y-como-calcularlos/",
        pais: "AR"
    },
    {
        titulo: "Documentos para transferir un auto: trámites, gastos y tiempos",
        descripcion: "Existen varios documentos para transferir un auto que hay que tener en cuenta antes de realizar una transacción de compraventa.",
        link: "https://segurarse.com.ar/blog/2023/10/25/documentos-para-transferir-un-auto-tramites-gastos-y-tiempos/",
        pais: "AR"
    },
    {
        titulo: "¿Qué es el certificado de grabado de autopartes?",
        descripcion: "El certificado de grabado de autopartes es un documento muy importante a tener en cuenta para evitar consecuencias legales.",
        link: "https://segurarse.com.ar/blog/2023/10/26/que-es-el-certificado-de-grabado-de-autopartes/",
        pais: "AR"
    },
    {
        titulo: "Seguro para autos viejos: qué opciones hay en Argentina",
        descripcion: "Existen múltiples tipos de seguro para autos viejos para proteger aquellos vehículos que acarrean décadas de historia.",
        link: "https://segurarse.com.ar/blog/2023/12/27/seguro-para-autos-viejos-que-opciones-hay-en-argentina/",
        pais: "AR"
    },
    {
        titulo: "Qué es el seguro de vida obligatorio para trabajadores",
        descripcion: "Los empleadores argentinos están obligados a hacer frente a una serie de cargas sociales para garantizar derechos de sus trabajadores en relación de dependencia. Para qué sirve el seguro de vida obligatorio para trabajadores y qué cobertura tiene.",
        link: "https://segurarse.com.ar/blog/2022/12/21/que-es-el-seguro-de-vida-obligatorio-para-trabajadores/",
        pais: "AR"
    },
    {
        titulo: "Diferencias entre hurto y robo para el seguro",
        descripcion: "Cuáles son los pasos a seguir si roban o hurtan tu vehículo. Qué debes hacer ante la policía, tu compañía aseguradora y el registro automotor.",
        link: "https://segurarse.com.ar/blog/2023/03/31/diferencias-entre-hurto-y-robo-para-el-seguro/",
        pais: "AR"
    },
    {
        titulo: "Me chocaron el auto estacionado y se fueron: ¿qué hago?",
        descripcion: "Como en todo accidente de tránsito, si te chocaron el auto estacionado y se fueron, lo primero que hay que hacer es el reclamo.",
        link: "https://segurarse.com.ar/blog/2024/04/22/me-chocaron-el-auto-estacionado-y-se-fueron-que-hago/",
        pais: "AR"
    },
    {
        titulo: "El seguro contra incendio ¿es obligatorio para el inquilino?",
        descripcion: "Contar o no con un seguro contra incendio es una de las dudas más frecuentes entre los inquilinos por su importancia y costo.",
        link: "https://segurarse.com.ar/blog/2023/11/23/el-seguro-contra-incendio-es-obligatorio-para-el-inquilino/",
        pais: "AR"
    },
    {
        titulo: "Seguro del Mercosur: cómo asegurar mi auto si viajo al exterior",
        descripcion: "Una breve guía para saber qué cobertura ofrece, cómo conseguirlo y en qué países de la región te permitirá circular.",
        link: "https://segurarse.com.ar/blog/2022/06/24/seguro-del-mercosur-como-asegurar-mi-auto-si-viajo-al-exterior/",
        pais: "AR"
    },
    {
        titulo: "¿Cuál es la presión de aire indicada para los neumáticos?",
        descripcion: "Es esencial controlar adecuadamente la presión de aire de los neumáticos para evitar accidentes y ahorrar combustible.",
        link: "https://segurarse.com.uy/blog/2023/09/15/cual-es-la-presion-de-aire-indicada-para-los-neumaticos/",
        pais: "UY"
    },
    {
        titulo: "Controles: dónde están los nuevos radares de velocidad",
        descripcion: "Es importante saber dónde están los nuevos radares de velocidad para no sufrir costosas multas de tránsito.",
        link: "https://segurarse.com.uy/blog/2023/12/27/controles-donde-estan-los-nuevos-radares-de-velocidad/",
        pais: "UY"
    },
    {
        titulo: "Cómo calcular cuánto pagarás por un seguro de moto",
        descripcion: "Una guía con todo lo que necesitás saber para calcular el precio de un seguro para tu moto.",
        link: "https://segurarse.com.uy/blog/2024/12/19/como-calcular-cuanto-pagaras-por-un-seguro-de-moto/",
        pais: "UY"
    },
    {
        titulo: "Qué es la cláusula de no repetición y por qué es importante",
        descripcion: "La cláusula de no repetición es una de las partes más importantes de un contrato de seguro, por lo que hay que entender qué es exactamente.",
        link: "https://segurarse.com.uy/blog/2024/07/29/que-es-la-clausula-de-no-repeticion-y-por-que-es-importante/",
        pais: "UY"
    },
    {
        titulo: "Cuáles son los autos más seguros",
        descripcion: "Cuáles son los modelos más seguros del mercado actual y en qué se destacan en cuanto a elementos y tecnología.",
        link: "https://segurarse.com.uy/blog/2023/05/02/cuales-son-los-autos-mas-seguros/",
        pais: "UY"
    },
    {
        titulo: "Cuál es el seguro de coche más barato en Uruguay",
        descripcion: "Consejos a tener en cuenta a la hora de contratar el seguro para tu coche en Uruguay, de manera eficiente y conveniente financieramente.",
        link: "https://segurarse.com.uy/blog/2022/11/14/cual-es-el-seguro-de-coche-mas-barato-en-uruguay/",
        pais: "UY"
    },
    {
        titulo: "Garantía de alquiler: qué es y por qué es importante",
        descripcion: "El seguro de garantía de alquiler ofrecerá beneficios tanto para el propietario del inmueble como para el inquilino que lo contrate.",
        link: "https://segurarse.com.uy/blog/2023/09/21/garantia-de-alquiler-que-es-y-por-que-es-importante/",
        pais: "UY"
    },
    {
        titulo: "Se me venció la licencia de conducir: ¿qué debo hacer?",
        descripcion: "Para moverse en cualquier vehículo es necesario tener la libreta de conducir al día. Si bien la mayoría de las libretas son físicas, en algunas zonas de Uruguay ya piensan en la posibilidad de una licencia digital a través de una app.",
        link: "https://segurarse.com.uy/blog/2022/06/28/se-me-vencio-la-licencia-de-conducir-que-debo-hacer/",
        pais: "UY"
    },
    {
        titulo: "¿Qué cubre el Seguro contra Terceros?",
        descripcion: "Contratar un seguro para tu auto es de carácter obligatorio, pero el elegir las distintas opciones como coberturas es optativo y si se preguntan ¿qué me cubre el seguro contra terceros? A continuación te vamos a explicar qué es y qué cubre.",
        link: "https://segurarse.com.uy/blog/2020/09/17/que-cubre-el-seguro-contra-terceros/",
        pais: "UY"
    },
    {
        titulo: "Auto eléctrico: precios, seguros y beneficios",
        descripcion: "Cuánto sale un auto eléctrico y cuáles son sus ventajas y desventajas. Todo lo que hay que saber antes de comprar.",
        link: "https://segurarse.com.uy/blog/2024/01/30/auto-electrico-precios-seguros-y-beneficios/",
        pais: "UY"
    },
    {
        titulo: "Cómo acceder a las mejores aseguradoras del país.",
        descripcion: "Con el respaldo de corredores especializados como Segurarse, los usuarios pueden comparar propuestas, analizar coberturas y contratar seguros de forma más simple, rápida y segura.",
        link: "https://segurarse.com.uy/blog/2025/09/12/como-acceder-a-las-mejores-aseguradoras-del-pais/",
        pais: "UY"
    },
    {
        titulo: "Cómo acceder a las mejores aseguradoras del país",
        descripcion: "Con el respaldo de brókers especializados como Segurarse, los usuarios pueden comparar propuestas, analizar coberturas y contratar seguros de forma más simple, rápida y segura.",
        link: "https://segurarse.com.ar/blog/2025/09/12/como-acceder-a-las-mejores-aseguradoras-del-pais/",
        pais: "AR"
    },
];


export const home_coberturas: CobProps[] = [

    {
        icon: "#icon-seg-auto",
        label: "Auto",
        link: "/seguros-individuos-auto",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-moto",
        label: "Moto",
        link: "/seguros-individuos-moto",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-prepaga",
        label: "Prepaga Médica",
        link: "/seguros-individuos-prepaga",
        pais: ["AR"]
    },
    /*{
        icon: "#icon-seg-celular",
        label: "Celular",
        link: "/seguros-individuos-celular",
        pais: ["AR", "UY"]
    },*/
    {
        icon: "#icon-seg-hogar",
        label: "Hogar",
        link: "/seguros-individuos-hogar",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-acc-personales",
        label: "Accidentes Personales",
        link: "/seguros-individuos-AP",
        pais: ["AR"]
    },
    /*{
        icon: "#icon-seg-bolso",
        label: "Bolso Protegido",
        link: "/seguros-individuos-bolso"
    },*/
    {
        icon: "#icon-seg-viajero",
        label: "Asistencia al Viajero",
        link: "/seguros-individuos-asistencia",
        pais: ["AR"]
    },
    {
        icon: "#icon-seg-embarcaciones",
        label: "Embarcación",
        link: "/seguros-individuos-embarcacion",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-caucion",
        label: "Garantía de alquiler",
        link: "/seguros-individuos-garantia-alquiler",
        pais: ["UY"]
    },
];

export const home_virtudes = [
    {
        titulo: "Digital",
        descripcion: "Cotizás 100% online y en menos de un minuto",
        icono: "#icon-motivo-digital"
    },
    {
        titulo: "Rápido",
        descripcion: "Comparás en tiempo real coberturas y precios de todas las aseguradoras",
        icono: "#icon-motivo-rapido"
    },
    {
        titulo: "Transparente",
        descripcion: "Sin dar vueltas emitís online el seguro que mejor se adapta a vos",
        icono: "#icon-motivo-transparente"
    },
    {
        titulo: "Personalizado",
        descripcion: "Tenemos un equipo de asesores expertos para responder tus consultas",
        icono: "#icon-motivo-personalizado"
    },
]


//---------------------------------------------

//Landing Quienes somos --------------------------------

export const quienes_somos_novedades: INovedades[] = [
    {
        descripcion: "Intermediación de seguros utilizando tecnología avanzada. Obtener cotizaciones de las aseguradoras más importantes del mercado en tiempo real.",
        link: "https://www.forbesargentina.com/daily-cover/las-startups-tecnologicas-suben-agenda-a-gobierno-ponen-foco-silicon-valley-exportar-valor-mundo-n57087",
        img: forbesLogo,
        pais: "AR"
    },
    {
        descripcion: "El bróker pone a disposición su cotizador online para que, en cuestión de minutos, sepas precios y puedas emitir 100% online.",
        link: "https://ar.motor1.com/news/628396/noticias-breves-semana-509/",
        img: motor1Logo,
        pais: "AR"
    },
    {
        descripcion: "Bróker de seguros digital pionero en América Latina, con presencia en Argentina, Uruguay y Brasil,",
        link: "https://www.ambito.com/como-ganar-dolares-el-mundo-it-saber-programar-n5731264",
        img: ambitoLogo,
        pais: "AR"
    },
    {
        descripcion: "Segurarse, broker digital de seguros que está creando un laboratorio de IA orientado a la industria, pionero en Argentina, ya desarrolló un bot que acompaña en el proceso de compra digital de seguro.",
        link: "https://www.cronista.com/apertura/empresas/los-mil-usos-de-la-ia-en-la-argentina-que-resultados-les-esta-dando-a-las-empresas-nacionales/",
        img: cronistaLogo,
        pais: "AR"
    },
    {
        descripcion: "Se afianza el rol de Segurarse como player tecnológico en la distribución digital de seguros",
        link: "https://www.eldiariodecarlospaz.com.ar/sociedad/2023/12/19/se-afianza-el-rol-de-segurarse-como-player-tecnologico-en-la-distribucion-digital-de-seguros-190633.html",
        img: diariocarlospazLogo,
        pais: "AR"
    },
    {
        descripcion: "Segurarse lideró el proceso de transformación digital del mercado asegurador en América Latina. Agilidad y eficiencia puesta al servicio del cliente.",
        link: "https://www.bariloche2000.com/noticias/leer/descubre-el-secreto-la-patente-revela-el-precio-de-tu-seguro-de-auto/147845",
        img: bariloche2000Logo,
        pais: "AR"
    },
    {
        descripcion: "El bróker digital de seguros elaboró una guía para responder a los interrogantes más frecuentes que tienen los conductores respecto a esta clase de operativos.",
        link: "https://noticiasargentinas.com/sociedad/verano-y-seguridad-vial--que-pueden-pedirte-y--que-no-en-un-control-en-la-ruta-_a674a24ac4671a4fe68763104?srstlid=AfmBOopr1tAu8FcQwMB1cxwuB6e0Zsm5f6Y2F3l6lJJbYjKr3mvEy1v5_",
        img: noticiasargentinasLogo,
        pais: "AR"
    },
    {
        descripcion: "Las personas quieren utilizar los datos para mejorar la toma de decisiones.",
        link: "https://eleconomista.com.ar/negocios/sobreabundancia-datos-nuevo-drama-afecta-empresas-2023-n64970",
        img: eleconomistaLogo,
        pais: "AR"
    },
    {
        descripcion: "Hoy nos encontramos con perfiles mucho más humanizados, más orientados a resultados de negocio y a pensar en qué valor agregado le damos al cliente.",
        link: "https://www.clarin.com/servicios/ganar-sueldos-dolares-entrar-mundo-tecnologico-saber-programar_0_qwWrhkDDPb.html",
        img: clarinLogo,
        pais: "AR"
    },
    {
        descripcion: "Todo sobre accidentes de tránsito en Uruguay",
        link: "https://diarioeleste.net/todo-sobre-accidentes-de-transito-en-uruguay/",
        pais: "UY",
        img: diarioDelEste
    },
    {
        descripcion: "¿Estás seguro con tu seguro? (accidentes de tránsito en UY y datos para pisar el freno)",
        link: "https://infonegocios.biz/enfoque/estas-seguro-con-tu-seguro-accidentes-de-transito-en-uy-y-datos-para-pisar-el-freno",
        pais: "UY",
        img: infoNegocios
    },
    {
        descripcion: "El informe que explica por qué los uruguayos pagan lo que pagan de luz ",
        link: "https://elpueblodigital.uy/el-informe-que-explica-por-que-los-uruguayos-pagan-lo-que-pagan-de-luz/",
        pais: "UY",
        img: epd
    },
    {
        descripcion: "Son pioneros en la venta de seguros online y crecen en Uruguay",
        link: "https://www.subrayado.com.uy/son-pioneros-la-venta-seguros-online-y-crecen-uruguay-n888610",
        pais: "UY",
        img: subrayado
    },
    {
        descripcion: "Uruguay: El 50% de las nuevas empresas desaparece en 3 años, revela estudio",
        link: "https://www.carmeloportal.com/97733-uruguay-el-50-de-las-nuevas-empresas-desaparece-en-3-anos-revela-estudio",
        pais: "UY",
        img: carmelo
    },
    {
        descripcion: "Venta de vehículos eléctricos en Uruguay creció en 2023 80,9% en comparación con el año anterior",
        link: "https://ladiaria.com.uy/trabajo/articulo/2024/5/venta-de-vehiculos-electricos-en-uruguay-crecio-en-2023-809-en-comparacion-con-el-ano-anterior/",
        pais: "UY",
        img: ladiaria
    },
    {
        descripcion: "¿Asegurar un auto eléctrico es más caro que uno a nafta? (sí… y en MVD más que Punta del Este)",
        link: "https://infonegocios.biz/enfoque/asegurar-un-auto-electrico-es-mas-caro-que-uno-a-nafta-si-y-en-mvd-mas-que-punta-del-este",
        pais: "UY",
        img: infoNegocios
    },
    {
        descripcion: "Autos eléctricos versus autos a nafta: ¿cuánto cuesta asegurar ambos vehículos en Uruguay?",
        link: "https://www.elpais.com.uy/negocios/noticias/autos-electricos-versus-autos-a-nafta-cuanto-cuesta-asegurar-ambos-vehiculos-en-uruguay",
        pais: "UY",
        img: elpais
    },

];
//------------------------------------------------------

//Landing Individuos -----------------------------------

export const individuos_beneficios = {
    "AR": [
        {
            titulo: <span>Respuesta <br />inmediata</span>,
            descripcion: "Tenemos múltiples canales de atención personalizada. La satisfacción de nuestros asegurados es prioridad absoluta.",
            icono: "#icon-motivo-rapido"
        },
        {
            titulo: <span>Gestiones de <br /><span style={{ fontSize: "21px" }}>siniestros y cobranzas</span></span>,
            descripcion: "Nos involucramos en todo el proceso, nuestro servicio es integral.",
            icono: "#icon-motivo-g-siniestros"
        },
        {
            titulo: <span>App <br />Mi Segurarse</span>,
            descripcion: "Autogestioná tu seguro desde tu celular. Es fácil y rápido. Es para vos.",
            icono: "#icon-motivo-misegurarse"
        },
        {
            titulo: "Descuentos exclusivos en otros riesgos",
            descripcion: "Somos tu bróker de confianza, decinos que buscas asegurar y te ayudamos.",
            icono: "#icon-motivo-descuentos"
        },
    ],
    "UY": [
        {
            titulo: <span>Respuesta <br />inmediata</span>,
            descripcion: "Tenemos múltiples canales de atención personalizada. La satisfacción de nuestros asegurados es prioridad absoluta.",
            icono: "#icon-motivo-rapido"
        },
        {
            titulo: <span>Gestiones de <br /><span style={{ fontSize: "21px" }}>siniestros y cobranzas</span></span>,
            descripcion: "Nos involucramos en todo el proceso, nuestro servicio es integral.",
            icono: "#icon-motivo-g-siniestros"
        },
        {
            titulo: <span>App <br />Mi Segurarse</span>,
            descripcion: "Autogestioná tu seguro desde tu celular. Es fácil y rápido. Es para vos.",
            icono: "#icon-motivo-misegurarse"
        },
        {
            titulo: "Descuentos exclusivos en otros riesgos",
            descripcion: "Somos tu corredor de seguros de confianza, decinos que buscas asegurar y te ayudamos.",
            icono: "#icon-motivo-descuentos"
        },
    ],
    "BR": []
}


export const individuos_coberturas = [
    {
        icon: "#icon-seg-auto",
        label: "Auto",
        link: "/seguros-individuos-auto",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-moto",
        label: "Moto",
        link: "/seguros-individuos-moto",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-prepaga",
        label: "Prepaga Médica",
        link: "/seguros-individuos-prepaga",
        pais: ["AR"]
    },
    /*{
        icon: "#icon-seg-celular",
        label: "Celular",
        link: "/seguros-individuos-celular"
    },*/
    {
        icon: "#icon-seg-hogar",
        label: "Hogar",
        link: "/seguros-individuos-hogar",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-acc-personales",
        label: "Accidentes Personales",
        link: "/seguros-individuos-AP",
        pais: ["AR"]
    },
    /*{
        icon: "#icon-seg-bolso",
        label: "Bolso Protegido",
        link: "/seguros-individuos-bolso"
    },*/
    {
        icon: "#icon-seg-viajero",
        label: "Asistencia al Viajero",
        link: "seguros-individuos-asistencia",
        pais: ["AR"]
    },
    {
        icon: "#icon-seg-embarcaciones",
        label: "Embarcación",
        link: "/seguros-individuos-embarcacion",
        pais: ["AR", "UY"]
    },
    {
        icon: "#icon-seg-caucion",
        label: "Garantía de alquiler",
        link: "/seguros-individuos-garantia-alquiler",
        pais: ["UY"]
    },
];



//------------------------------------------------------

//Landing One Team -----------------------------------

export const one_team_espiritu = [
    {
        icon: "#icon-espiritu-01",
        titulo: "FLEXIBILIDAD",
        descripcion: "Nos apasionan los nuevos desafíos y sabemos adaptarnos al cambio permanente con agilidad."
    },
    {
        icon: "#icon-espiritu-02",
        titulo: "COMPROMISO",
        descripcion: "Asumimos seriamente nuestro compromiso de negocio con alta vocación de servicio y actitud responsable."
    },
    {
        icon: "#icon-espiritu-03",
        titulo: "APERTURA",
        descripcion: "Tenemos un pensamiento abierto, buscamos soluciones e innovación, respetando la diversidad y aceptando nuestras diferencias."
    },
    {
        icon: "#icon-espiritu-04",
        titulo: "INTEGRIDAD",
        descripcion: "Aseguramos que todo lo que hacemos para nuestros clientes y nuestra gente se realice con transparencia."
    }
]


//----------------------------------------------------

//Landing Politicas de privacidad -----------------------------------

export const politicas_privacidad = [
    {
        titulo: "Introducción:",
        content: (<>
            El sitio Segurarse.com.ar pertenece a <b>Segurarse Asesores de Seguros S.A.</b>,
            productores asesores de seguros conforme surge de la Ley 22.400 matrícula 1174,
            expedida por la Superintendencia de Seguros de la Nación
            (<a className="text-decoration-underline" href="https://www.ssn.gob.ar/" target="_blank" rel="noreferrer">www.ssn.gob.ar</a>),
            no revistiendo el carácter de compañía de seguros, con domicilio fiscal en Av. Bartolomé Mitre 1249 P.B. "B",
            Florida Oeste, Buenos Aires, Argentina. El pilar del sitio Segurarse.com.ar es ayudar al usuario a informarse y
            educarse sobre la distinta gama de seguros y también se le permite al usuario interesado solicitar múltiples
            cotizaciones online por intermedio de un formulario web. Para esto el usuario otorga voluntariamente sus datos
            personales de contacto y otros datos necesarios para poder cotizar online como por ejemplo los datos del vehículo
            en el caso de seguros de auto. Los datos personales voluntariamente otorgados pueden ser utilizados por Segurarse.com.ar
            y/o <i>Segurarse Asesores de Seguros S.A.</i> para brindar respuestas y soporte personalizado.
        </>)
    },
    {
        titulo: "Uso de la información recopilada:",
        content: <>Segurarse Asesores de Seguros S.A., con domicilio en Av. Bartolomé Mitre 1249 P.B. "B", Florida Oeste,
            Buenos Aires, Argentina, es el responsable por el tratamiento de sus datos personales y el titular de la base de datos
            registrada ante la Dirección Nacional de Protección de datos personales.
            <span> </span><a className="ml-1 text-decoration-underline" href="https://www.argentina.gob.ar/aaip/datospersonales" target="_blank" rel="noreferrer">Aquí</a>.
            <br className="mt-3" />
            Segurarse.com.ar, utiliza los datos personales de contactos recopilados con el solo objetivo de proporcionar información
            acerca de las cotizaciones online que el mismo usuario solicita de forma voluntaria y son destinados a responder y/o dar
            soporte a las consultas que el usuario formula en tiempo y forma. Este es el único uso de la información que el usuario
            otorga voluntariamente.<br /><br />
            El usuario consiente en forma expresa, informada, voluntaria e inequívoca el tratamiento de sus datos personales por
            Segurarse.com.ar, de acuerdo con los términos de esta Política de Privacidad.<br /><br />
            AL ACCEDER, CONECTARSE Y/O DE CUALQUIER OTRA FORMA UTILIZAR EL SITIO, EL USUARIO. CONFIRMA QUE HA LEÍDO,
            ENTENDIDO, CONSIENTE Y ACEPTA LOS TÉRMINOS Y CONDICIONES DE ESTAS POLÍTICAS DE PRIVACIDAD.
            SI EL USUARIO NO ESTÁ DE ACUERDO CON LOS TÉRMINOS DE LAS POLÍTICAS DE PRIVACIDAD, POR FAVOR NO UTILICE ESTE SITIO.
        </>
    },
    {
        titulo: "Menores de edad:",
        content: <>
            Segurarse.com.ar se compromete a no discriminar a ningún usuario basándose en su raza, género, orientación sexual,
            religión, discapacidad u origen étnico. Todas las prácticas comerciales serán transparentes, proporcionando
            información clara y comprensible sobre productos, servicios y políticas. Segurarse.com.ar garantiza que todos los
            usuarios tengan acceso equitativo a nuestros productos y servicios, teniendo en cuenta posibles barreras físicas o
            tecnológicas.
        </>
    },
    {
        titulo: "Derechos del usuario titular de los datos personales. Seguridad:",
        content: <>
            Segurarse.com.ar presume y el usuario garantiza, la veracidad de toda la información que sea suministrada por el usuario.
            En consecuencia, Segurarse.com.ar no verifica, ni asume la obligación de verificar la veracidad, vigencia, suficiencia,
            legalidad y autenticidad de los datos que el usuario proporcione. El usuario asume la responsabilidad de mantener dicha
            información actualizada en todo momento.
            <br /><br />
            El usuario podrá acceder en forma gratuita a la información que suministró a Segurarse.com.ar, en intervalos no menores
            a seis meses, salvo que acredite un interés legítimo al efecto, conforme lo previsto en la Ley de Protección de Datos
            Personales Nº 25.326.
            <br /><br />
            Si los datos del usuario son incorrectos, desea actualizarlos y/o suprimirlos, Segurarse.com.ar corregirá, actualizará y/o
            suprimirá esa información al requerimiento del usuario sin costo alguno. Para ejercer los derechos de acceso, rectificación,
            actualización o supresión, conforme lo previsto en la Normativa de Protección de Datos Personales, el usuario deberá enviar
            un correo electrónico a <span> </span>
            <a className="text-decoration-underline" href="mailto:compliance@segurarse.com.ar">
                compliance@segurarse.com.ar</a>.
            indicando qué derecho quiere ejercer y acreditando su identidad enviando
            una foto de frente y dorso de su DNI.
            <br /><br />
            La información suministrada por el usuario será almacenada de forma segura por Segurarse.com.ar y, asimismo, sólo será
            usada para cumplir con los fines legítimos respecto de los cuales Segurarse.com.ar deba conservar sus datos personales.
            <br /><br />
            Los datos recabados se mantendrán en confidencialidad y reserva. Segurarse.com.ar sólo usará los datos a los fines y de
            la manera informada en estas Políticas de Privacidad. Segurarse.com.ar cumple con la normativa de protección de datos
            personales y en particular, con la Ley N° 25.326 y sus normas complementarias. Para garantizar la seguridad de los datos
            personales que el usuario proporcione, Segurarse.com.ar aplicará los mismos criterios y el mismo grado de diligencia que
            aplica para resguardar su propia información. Sin embargo, el usuario reconoce que los medios técnicos existentes que
            brindan seguridad no son inquebrantables y que, aunque se adopten todos los recaudos razonables de seguridad, es posible
            sufrir manipulaciones, destrucción y/o pérdida de información.
        </>
    },
    {
        titulo: "Propiedad de la información:",
        content: <>
            Una vez ingresado un formulario con información personal al sitio, estos datos serán propiedad de Segurarse.com.ar
            (Segurarse Asesores de Seguros S.A.) con domicilio fiscal en Av. Bartolomé Mitre 1249 P.B. "B", Florida Oeste, Buenos
            Aires, Argentina, y el usuario estará aceptando las políticas de privacidad de este sitio; por lo que, si el usuario no
            está de acuerdo con las mismas, este no deberá suministrar sus datos personales. Segurarse.com.ar se reserva el derecho
            a modificar sus políticas de privacidad con aviso previo.
        </>
    },
    {
        titulo: "Acerca de las Cookies del sitio:",
        content: <>
            El usuario conoce y acepta que Segurarse.com.ar podrá utilizar un sistema de seguimiento mediante la utilización de
            <span> </span><b>cookies</b>. Las cookies son pequeños archivos, con una duración limitada en el tiempo que permiten personalizar los
            servicios. Se establece que la instalación, permanencia y existencia de las cookies en la computadora y/o dispositivo del
            Usuario depende de su exclusiva voluntad y puede ser eliminada de su computadora y/o dispositivo cuando el usuario así
            lo desee.
        </>
    },
    {
        titulo: "Acerca de las Cookies de Google:",
        content: <>
            Segurarse.com.ar utiliza Google Analytics para analizar el uso de este sitio web. Google Analytics genera información
            estadística sobre el uso del sitio por medio de cookies, que se almacenan en los ordenadores de los usuarios.
            La información generada en relación con nuestro sitio web se utiliza para crear informes sobre el uso de la página web.
            Google va a almacenar y utilizar esta información. Política de privacidad de Google está disponible en:<span> </span>
            <a className="text-decoration-underline"
                href="http://www.google.com/privacypolicy.html"
                target="_blank"
                rel="noreferrer"
            >http://www.google.com/privacypolicy.html</a><br /><br />
            El usuario conoce y acepta que Segurarse.com.ar puede utilizar herramientas de terceros para analizar el uso de este
            sitio web por medio de cookies, que se almacenan en los ordenadores de los usuarios. La información generada en relación
            con nuestro sitio web se utiliza para mejorar la experiencia de navegabilidad.
            Si el usuario lo desea puede eliminar el uso de cookies de almacenamiento de información de manera voluntaria, en
            cualquier momento, a través de la configuración en su navegador. Debe tener en cuenta que esto podría provocar que el
            sitio no funcione en todo su potencial.
        </>
    },
    {
        titulo: "Preguntas y sugerencias:",
        content: <>
            En el caso de que el usuario tenga alguna duda o sugerencia, podrá hacerla vía email a <span> </span>
            <a className="text-decoration-underline" href="mailto:consultas@segurarse.com.ar"> consultas@segurarse.com.ar</a>,
            donde sus opiniones serán evaluadas y analizadas.
        </>
    },
    {
        titulo: "Botón de arrepentimiento:",
        content: <>
            Conforme Resolución 424/2020, de la Secretaria de Comercio Interior, las y los clientes pueden solicitar la revocación de
            la aceptación durante el plazo de <b>DIEZ (10) días corridos</b> contados a partir de la fecha de la celebración del seguro
            contratado únicamente mediante el canal ecommerce de la web
            (<Link className="text-decoration-underline" to="/" target="_blank">www.segurarse.com.ar</Link>)
            <span> </span>
            <Link className="text-decoration-underline" to="/formulario-arrepentimiento" target="_blank" rel="noreferrer">Ver más</Link>
        </>
    }
]

export const politicas_privacidad_uy = [
    {
        titulo: "",
        content: <>
            SEGURARSE S.R.L. (en adelante “SEGURARSE”), con domicilio en Havre 2210 de la ciudad de Montevideo, Uruguay, es corredor de seguros sin que revista el carácter de compañía de seguros o reaseguros. SEGURARSE es titular del sitio web y dominio <a className="text-decoration-underline" href="https://segurarse.com.uy">www.segurarse.com.uy</a> (en adelante “el Sitio”), y responsable de los datos de carácter personal que sean suministrados por los usuarios a través de este Sitio.<br /><br />
            El pilar del Sitio es ayudar al usuario a informarse y educarse sobre la distinta gama de seguros, así como también permitirle al usuario interesado solicitar múltiples cotizaciones online por intermedio de un formulario web a completarse y enviarse a través del Sitio. Para esto, el usuario otorga voluntariamente sus datos personales de contacto y otros datos necesarios para poder realizar la cotización online, como por ejemplo los datos de su vehículo en el caso de cotizar un seguro para vehículo automotor. Los datos personales voluntariamente otorgados pueden ser utilizados por el Sitio y/o SEGURARSE para brindar respuestas y soporte
            personalizado al usuario.<br /><br />
            Si los datos suministrados a SEGURARSE son de terceros distintos del usuario, éste último garantiza haber recabado y contar con el consentimiento previo y por escrito de dichos terceros para la comunicación de sus datos, así como también garantiza haberles informado, de forma previa a su suministro a SEGURARSE, las finalidades del tratamiento, comunicaciones y demás términos previstos en estas “Políticas de Privacidad y
            Protección de Datos Personales”.<br /><br />
            SEGURARSE presume y el usuario garantiza la exactitud y veracidad de todos los datos personales e información que sean suministrados por el usuario. En consecuencia, SEGURARSE y el Sitio no verifican ni asumen la obligación de verificar la veracidad, vigencia, suficiencia, legalidad y autenticidad de los datos que el usuario proporcione. El usuario asume la responsabilidad de mantener dicha información y datos personales debidamente actualizados, y a comunicar a SEGURARSE y/o al Sitio cualquier variación que se
            produzca en los mismos.<br /><br />
            La utilización de este Sitio está sujeta a la “Política de Privacidad y Protección de Datos Personales” y a la “Política de Cookies” que se detallan a continuación. Por favor, léalas atentamente. EL HECHO DE ACCEDER, CONECTARSE Y/O DE CUALQUIER OTRA FORMA UTILIZAR EL SITIO, IMPLICA QUE EL USUARIO PREVIAMENTE HA LEÍDO, ENTENDIDO, CONSIENTE Y ACEPTA, SIN RESERVA ALGUNA, LOS TÉRMINOS Y CONDICIONES DE ESTAS “POLÍTICAS DE PRIVACIDAD Y PROTECCIÓN DE DATOS PERSONALES” Y “POLÍTICAS DE COOKIES”. SI EL USUARIO NO ESTÁ DE ACUERDO CON LOS TÉRMINOS DE DICHAS POLÍTICAS, POR FAVOR NO UTILICE ESTE SITIO.
            SEGURARSE se reserva el derecho de modificar sus políticas de privacidad y protección de datos personales, previo aviso a efectuarse por los mismos medios en que las dio a conocer a los usuarios.
        </>
    },
    {
        titulo: "Información sobre la protección de datos personales y utilización de la información recopilada:",
        content: <>
            SEGURARSE, inscripta en el Registro Único Tributario con el número 218197840014, con domicilio en Havre 2210 de la ciudad de Montevideo, Uruguay, es la titular de la base de datos y la responsable por el tratamiento de los datos personales suministrados por los usuarios durante la navegación y/o utilización del Sitio.
            Todos los datos personales recopilados con la navegación y/o utilización del Sitio que haga el usuario, recogidos con los correspondientes formularios web, serán tratados conforme con estas “Políticas de Privacidad y Protección de Datos Personales”. Dichos datos personales recopilados se utilizarán únicamente con las siguientes finalidades:
            <br /><br />
            <ul>
                <li>Proporcionar información acerca de las cotizaciones online que el mismo usuario solicita de forma voluntaria a través del Sitio;</li>
                <li>Responder y/o dar soporte, en tiempo y forma, a las consultas que el usuario formula;</li>
                <li>Cumplir con las normas y obligaciones legales que resulten aplicables a SEGURARSE;</li>
                <li>Gestionar de forma integral y centralizada la relación del usuario con las distintas entidades del Grupo SEGURARSE;</li>
                <li>Mantener informados a los usuarios acerca de los productos o servicios, con el fin de proporcionarles un mejor servicio;</li>
                <li>Ofrecerle al usuario una navegación más personalizada en el Sitio;</li>
                <li>Conocer las horas de mayores visitas del Sitio, así como también realizar los ajustes que sean necesarios en el Sitio para evitar problemas de acceso al mismo por parte de los usuarios y, así, ofrecerles una mejor experiencia en su navegación;</li>
                <li>Conocer la eficacia de los distintos enlaces del Sitio, para mejorarlos o potenciarlos;</li>
                <li>Enviarle al usuario información y publicidad sobre ofertas, productos, servicios, recomendaciones y promociones, así como también extraer, almacenar datos y estudios de marketing, con el objeto de adecuar las ofertas comerciales de SEGURARSE al perfil particular del usuario.</li>
            </ul>
            <br /><br />
            Los anteriores son los únicos y exclusivos usos de la información y finalidades del tratamiento de los datos personales que el usuario otorga y consiente voluntariamente. Por lo que SEGURARSE solamente utilizará dichos datos para los fines y de la manera informada en estas “Políticas de Privacidad y Protección de Datos Personales”.
            <br /><br />
            SEGURARSE garantiza a los usuarios que no estuvieran de acuerdo con las finalidades para las cuales recaba los datos, el derecho de obtener la supresión de los mismos de su base de datos.
            <br /><br />
            SEGURARSE podrá comunicar sus datos, exclusivamente para las finalidades indicadas en este apartado, a otras entidades pertenecientes al Grupo SEGURARSE como a la matriz, sucursales y/o filiales (<a className="text-decoration-underline" href="https://segurarse.com.ar/" target="_blank">www.segurarse.com.ar</a>, <a className="text-decoration-underline" href="https://segurarse.com.br/" target="_blank">www.segurarse.com.br</a> y <a className="text-decoration-underline" href="https://segurarse.com.uy/" target="_blank">www.segurarse.com.uy</a>), así como también a terceros con los cuales suscriba acuerdos de colaboración, en la medida que dichos acuerdos tengan por objeto la colaboración o auxilio en el desarrollo y/o ejecución de los servicios que el usuario contrata de SEGURARSE. Asimismo, SEGURARSE se reserva el derecho de comunicar tales datos personales a las autoridades competentes, siempre y cuando le sea requerido por éstas últimas por obligación legal, o cuando le sea obligatorio a SEGURARSE remitirlos por norma legal.
            <br /><br />
            Asimismo, cualquier entidad perteneciente al Grupo SEGURARSE puede comunicar los datos personales a cualquier otra entidad del referido Grupo, con la finalidad de mantener una gestión centralizada y completa de la relación de los usuarios con las distintas entidades del Grupo SEGURARSE. Lo que beneficiará a los usuarios en poder tener acceso a sus datos personales desde cualquiera de dichas entidades del Grupo, respetando en todo caso la legislación aplicable sobre protección de datos personales.
            <br /><br />
            A su vez, y en consonancia con el párrafo anterior, se podrán realizar transferencias internacionales de datos a terceros países, concretamente a la matriz y/o sucursales y/o filiales del Grupo SEGURARSE, sobre los que exista un adecuado nivel de protección de datos personales acorde con los estándares internacionales o regionales. Las transferencias internacionales referidas en este párrafo que no puedan garantizar un nivel de adecuado protección, serán excepcionales y se realizarán únicamente si son necesarias e imprescindibles para el desarrollo de su relación con el usuario y con el consentimiento expreso, inequívoco y por escrito del usuario.
            <br /><br />
            El usuario queda informado y consiente en forma expresa, informada, voluntaria e inequívoca que el tratamiento de sus datos personales, suministrados a SEGURARSE durante la navegación y utilización del Sitio, así como también aquellos que se generasen por la utilización del Sitio (incluidas las comunicaciones de datos o las transferencias internacionales de los datos que pudieran realizarse con las finalidades indicadas en este apartado), sea de conformidad con los términos y condiciones de esta “Política de Privacidad y Protección de Datos Personales”.
        </>
    },
    {
        titulo: "Derechos del usuario titular de los datos personales. Seguridad de los datos personales:",
        content: <>
            En los términos y con el alcance dispuesto en estas “Políticas de Privacidad y Protección de Datos Personales” y la normativa vigente en materia de protección de datos personales (Ley 18.331 y sus Decretos Reglamentarios 414/009 y 64/020 de fechas 31 de agosto de 2009 y 17 de febrero de 2020 respectivamente), todo usuario titular de datos personales tiene derecho a
            <br /><br />
            <ul>
                <li>Confirmar si en SEGURARSE existen y/o se están tratando datos personales del usuario (o que le conciernan), así como también a tener acceso gratuito a toda la información y datos personales suministrados a SEGURARSE, en intervalos no menores a seis meses, salvo que el usuario acredite un interés legítimo al efecto, conforme a lo previsto en la Ley de Protección de Datos Personales Nº 18.331.</li>
                <li>Solicitar la corrección, rectificación, actualización, inclusión y/o la supresión o cancelación de datos personales
                    proporcionados a SEGURARSE, a su solo requerimiento y sin costo alguno, si los mismos fueren incorrectos,
                    desea actualizarlos, incluir nuevos datos y/o suprimirlos o cancelarlos. Para ejercer los derechos de acceso
                    (referido en el ítem anterior), rectificación, actualización, inclusión o supresión, conforme a lo previsto en la
                    normativa de protección de datos personales, el usuario deberá enviar un correo electrónico a
                    <a className="text-decoration-underline" href="mailto:compliance@segurarse.com.uy"> compliance@segurarse.com.uy</a>, indicando qué derecho quiere ejercer y acreditando su identidad con el envío de una foto o escaneo de frente y dorso de su cédula de identidad y/o poder respectivo con facultades suficientes, según corresponda.
                </li>
                <li>Oponerse al tratamiento de sus datos personales. En tal caso, SEGURARSE dejará de tratar los datos, salvo que sean necesarios para la defensa de posibles reclamaciones, informando de ello al usuario.</li>
                <li>Retirar el consentimiento otorgado para el tratamiento de sus datos personales -para las finalidades indicadas en estas Políticas de Privacidad y Protección de Datos Personales-, sin que ello afecte la licitud del tratamiento realizado en base a un consentimiento previo a su retirada.</li>
            </ul>
            Los datos personales recabados de los usuarios se mantendrán en confidencialidad y reserva.
            SEGURARSE se compromete a realizar sus mayores esfuerzos, considerando la tecnología disponible a los efectos de almacenar y proteger, y conforme a niveles de protección adecuados, la información personal que el usuario suministre a SEGURARSE. Para ello, SEGURARSE ha adoptado medidas seguridad que protegen dicha información personal, aplicando los mismos criterios y el mismo grado de diligencia que aplica para resguardar su propia información.
            No obstante, el usuario reconoce que los medios técnicos existentes que brindan seguridad (y en especial las medidas de seguridad que se tomen en Internet) no son inquebrantables, pues aun cuando se adopten todos los recaudos razonables de seguridad, es posible sufrir manipulaciones, destrucción y/o pérdida de información. Por lo tanto, SEGURARSE no puede garantizar una seguridad absoluta de resguardo de la información personal suministrada por el usuario y, en consecuencia, SEGURARSE no se responsabiliza de ningún daño y/o perjuicio y/o beneficios dejados de percibir por el usuario titular de los datos personales o cualquier otro tercero que se vea perjudicado en este sentido.
        </>
    },
    {
        titulo: "Jurisdicción y legislación aplicable:",
        content: <>
            Las presentes “Políticas de Privacidad y Protección de Datos Personales” y “Políticas de Cookies”, sobre el tratamiento de los datos personales de los usuarios del Sitio, se rigen por las leyes de la República Oriental del Uruguay. Cualquier disputa o reclamo que surja con relación a las mismas, incluyendo cualquier disputa sobre la validez, interpretación, exigibilidad o incumplimiento, serán exclusivamente resueltas por los tribunales de la ciudad de Montevideo, República Oriental del Uruguay; renunciando a todo otro fuero y/o jurisdicción competente.
        </>
    },
    {
        titulo: "Declaración de SEGURARSE:",
        content: <>
            SEGURARSE se compromete a no discriminar a ningún usuario basándose en su raza, género, orientación sexual, religión, discapacidad u origen étnico. Todas las prácticas comerciales serán transparentes, proporcionando información clara y comprensible sobre productos, servicios y políticas. SEGURARSE garantiza que todos los usuarios tengan acceso equitativo a nuestros productos y servicios, teniendo en cuenta las posibles barreras físicas o tecnológicas.
        </>
    },
    {
        titulo: "POLÍTICA DE COOKIES:",
        content: <></>
    },
    {
        titulo: "Acerca de las cookies del Sitio:",
        content: <>
            Al igual que la mayoría de las empresas que operan mediante Internet, SEGURARSE utiliza cookies para mejorar la experiencia de navegación de los usuarios en el Sitio, así como también ajustar dicha navegación a las necesidades de los usuarios en su próxima visita al Sitio y, en última instancia, personalizarle los servicios que ofrece al usuario. Por favor, lea atentamente la “Política de Cookies” para informarse acerca del uso que hace SEGURARSE de las cookies y las opciones que usted tiene sobre su configuración.
        </>
    },
    {
        titulo: "¿Qué son las cookies?:",
        content: <>
            Una cookie puede definirse como un pequeño fichero o archivo de texto que un servidor web almacena en su navegador desde el instante en el que se accede al mismo, para recordar información sobre su visita. La cookie se implanta en el disco duro de su ordenador y/o dispositivo, incorporando información relativa al usuario (como la frecuencia de visitas, la preferencia de contenidos visitados o seleccionados, los datos de inicio de sesión, o los elementos de seguridad que pueden intervenir en el control de acceso a áreas restringidas de navegación). Una vez que su navegador finaliza una sesión, la cookie implantada en el disco duro de su ordenador y/o dispositivo cesa de funcionar. Es importante recordar que nuestro Sitio será capaz de recordar la información que le concierne o la relativa a sus preferencias hasta el momento en el que la sesión de su navegador finaliza (si la cookie es temporal) o hasta el instante en el que es definitivamente eliminada de su sistema.
            <br /><br />Por lo tanto, la instalación, permanencia y existencia de las cookies en el disco duro de su ordenador y/o dispositivo depende de su exclusiva voluntad, pudiendo ser eliminada del disco duro de su ordenador y/o dispositivo cuando usted así lo desee.
            <br /><br />Por otra parte, informamos que nuestras cookies en ningún caso pueden ser ejecutadas como códigos o incluir virus en sus textos.
            <br /><br />En cuanto a las cookies de terceras partes o compañías que pudieran instalarse en el disco duro de su ordenador, SEGURARSE no asume responsabilidad alguna. El uso que hacen estas terceras partes o compañías estará sujeto a sus propias políticas de privacidad y cookies; no a la “Política de Privacidad y Protección de Datos Personales” y “Política de Cookies” de SEGURARSE.
            <br /><br />De acuerdo con lo anterior, usted conoce y acepta expresamente que SEGURARSE utilice un sistema de seguimiento del usuario mediante cookies, con el objeto de mejorar su experiencia durante la navegación y utilización del Sitio, así como también que SEGURARSE pueda brindarle servicios personalizados.
        </>
    },
    {
        titulo: "¿Cómo pueden desactivarse las cookies?:",
        content: <>
            Si con posterioridad usted desea bloquear, eliminar y/o inhabilitar nuestras cookies o las de Google (ver apartado siguiente) que se hayan almacenado en el disco duro de su ordenador y/o dispositivo, usted puede acceder al&nbsp;
            <a className="text-decoration-underline" href="https://adssettings.google.com" target="_blank">Administrador de preferencias de anuncios de Google</a> para cambiar la configuración, o también las puede bloquear, inhabilitar y/o eliminar desde el navegador web que usted utilice:
            <br /><br />
            <ul>
                <li><a className="text-decoration-underline" href="https://support.google.com/chrome/answer/95647?hl=es%20" target="_blank">Configurar cookies en Google Chrome</a></li>
                <li><a className="text-decoration-underline" href="https://support.microsoft.com/es-es/windows/administrar-cookies-en-microsoft-edge-ver-permitir-bloquear-eliminar-y-usar-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank">Configurar cookies en Microsoft Internet Explorer</a></li>
                <li><a className="text-decoration-underline" href="" target="_blank">Configurar cookies en Mozilla Firefox</a></li>
                <li><a className="text-decoration-underline" href="https://support.apple.com/es-es/HT201265%20" target="_blank">Configurar cookies en Safari</a></li>
                <li><a className="text-decoration-underline" href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank">Configurar cookies en Opera</a></li>
            </ul>
            Si usted no acepta las cookies, o con posterioridad las bloquea, elimina y/o inhabilita, la calidad y funcionalidades del Sitio podrían verse mermadas o podrían provocar que el Sitio no funcione en todo su potencial.
        </>
    },
    {
        titulo: "Acerca de las Cookies de Google:",
        content: <>
            SEGURARSE utiliza Google Analytics para analizar el uso de este Sitio.
            Google Analytics es una plataforma que recoge datos sobre el uso del Sitio (como la cantidad de visitas realizadas al Sitio, los hábitos de navegación en nuestro Sitio y su interacción con anuncios publicitarios), por medio de cookies que se almacenan en el disco duro del ordenador y/o dispositivo del usuario. La información generada en relación con nuestro Sitio se utiliza para crear informes estadísticos sobre el uso del Sitio. Google almacena y utiliza esta información de acuerdo con la “Política de Privacidad de Google”, la que se puede consultar a través del siguiente enlace:
            <a href="http://www.google.com/privacypolicy.html">{" http://www.google.com/privacypolicy.html. "}</a><br />
            El usuario conoce y acepta que SEGURARSE utilice herramientas de terceros para analizar el uso de este Sitio por medio de cookies. La información generada en relación con nuestro Sitio se utiliza para mejorar la experiencia de navegabilidad y ofrecer un servicio personalizado al usuario. Si usted lo desea, puede bloquear, eliminar y/o inhabilitar el uso de cookies de manera voluntaria y en cualquier momento, a través de la configuración en su navegador (ver apartado: “¿Cómo pueden desactivarse las cookies?”).
        </>
    },
    {
        titulo: "Cambios y actualizaciones en la Política de Cookies:",
        content: <>
            SEGURARSE y las empresas que conforman el Grupo SEGURARSE podrán modificar esta “Política de Cookies”, en función de la existencia de nuevas exigencias legislativas o reglamentarias, o con la finalidad de adaptar dicha política a las recomendaciones que dicten los organismos reguladores. En caso de modificar estas “Políticas de Cookies”, se publicarán en nuestro Sitio. Por lo tanto, se recomienda revisar periódicamente la “Política de Cookies”.
        </>
    },
    {
        titulo: "Preguntas y sugerencias:",
        content: <>
            En el caso de que el usuario tenga alguna duda o sugerencia, podrá hacerla vía e-mail a
            <a className="text-decoration-underline" href="mailto:consultas@segurarse.com.uy"> consultas@segurarse.com.uy</a>, donde sus opiniones serán evaluadas y analizadas.
        </>
    },
    {
        titulo: "Botón de arrepentimiento:",
        content: <>
            Conforme a la Ley 17.250, los clientes pueden solicitar la resolución o rescisión -de pleno derecho- del contrato celebrado vía online con SEGURARSE. Para ejercer este derecho, los clientes deben comunicar a SEGURARSE la resolución o rescisión del contrato dentro del plazo máximo de
            <b>{" CINCO (5) días hábiles "}</b> contados a partir de la fecha de la celebración del seguro contratado, mediante correo electrónico a la casilla
            <a className="text-decoration-underline" href="mailto:compliance@segurarse.com.uy"> compliance@segurarse.com.uy</a> o mediante el canal e-commerce de la web
            (<Link className="text-decoration-underline" to="/">{"www.segurarse.com.uy"}</Link>). De ejercerse este derecho de resolución o rescisión del contrato dentro del plazo indicado, no se generará responsabilidad alguna para el cliente.
            <Link className="text-decoration-underline" to="/formulario-arrepentimiento">{" Ver más."}</Link>
        </>
    }
]
//-------------------------------------------------------------------